import { ModelBase } from "../abstract/model-base.model";
import { AnalyticalAxis } from "./analytical-axis.model";
import { AnalyticalKey } from "./analytical-key.model";
import { AnalyticalSection } from "./analytical-section.model";

export class AnalyticalDefault extends ModelBase {

    static override CLASS_NAME: string = 'AnalyticalDefault';

    private _axis!: AnalyticalAxis;
    private _scopeId!: number;
    private _scopeLabel!: string;
    private _scopeType!: string;
    private _targetKey!: AnalyticalKey;
    private _targetSection!: AnalyticalSection;

    public get axis(): AnalyticalAxis {
        return this._axis;
    }

    public set axis(value: any) {
        this._setValue('_axis', value, 'AnalyticalAxis');
    }

    public get scopeId(): number {
        return this._scopeId;
    }

    public set scopeId(value: any) {
        this._setValue('_scopeId', value, 'integer');
    }

    public get scopeLabel(): string {
        return this._scopeLabel;
    }

    public set scopeLabel(value: any) {
        this._setValue('_scopeLabel', value, 'string');
    }

    public get scopeType(): string {
        return this._scopeType;
    }

    public set scopeType(value: any) {
        this._setValue('_scopeType', value, 'string');
    }

    public get targetKey(): AnalyticalKey {
        return this._targetKey;
    }

    public set targetKey(value: any) {
        this._setValue('_targetKey', value, 'AnalyticalKey');
    }

    public get targetSection(): AnalyticalSection {
        return this._targetSection;
    }

    public set targetSection(value: any) {
        this._setValue('_targetSection', value, 'AnalyticalSection');
    }
}
